<div class="flex justify-between py-1 px-5 shadow-xl shadow-black/15 bg-(--color-header-bg)">
  <div class="hidden sm:flex">
    <div class="flex gap-3">
      <img
        [attr.alt]="'headers.logoAlt' | translate"
        class="cursor-pointer h-16"
        src="assets/icons/logo-general.svg"
        (click)="this.goToUrl(['/home'], {})"
      />

      <div>
        {{ currentSection }}
      </div>
    </div>
  </div>

  <div class="flex justify-center items-center gap-4">
    <mat-icon [matMenuTriggerFor]="userProfile" class="w-8! h-8! text-[34px]! cursor-pointer"
      >account_circle</mat-icon
    >
  </div>
</div>
<mat-menu #userProfile="matMenu">
  <div class="flex justify-center items-center gap-4" (click)="logout()" mat-menu-item>
    <mat-icon class="w-7! h-7! text-[28px]! cursor-pointer">close</mat-icon>
    {{ 'headers.logout' | translate }}
  </div>
</mat-menu>
